module.exports = __webpack_public_path__ + "img/walk-q19n-1.1125ed3a.png";